import ajax from '@/libs/Ajax'

const nameSpace = '/aseapi/console/enthsminfomgr'

export default {
  save(param) {
    return ajax.post(`${nameSpace}/saveHsmInfo`, param)
  },
  select(param) {
    return ajax.get(`${nameSpace}/initList`, {
      params: param
    })
  },
  selectPro() {
    return ajax.get(`${nameSpace}/common/listConn`)
  },
  selectRpb() {
    return ajax.get(`${nameSpace}/common/listRpbChain`)
  },
  selectRouter() {
    return ajax.get(`${nameSpace}/common/listRouterType`)
  },
  deletes(uuid) {
    return ajax.post(`${nameSpace}/deleteHsmInfo`, uuid)
  },
  model(uuid, type) {
    return ajax.get(`${nameSpace}/common/mouldmgr/getJsonMouldByCnIDByType`, {
      params: {
        uuid: uuid,
        type: type
      }
    })
  },
  saveSendConf(param) {
    return ajax.post(`${nameSpace}/identitymgr/saveSendConfig`, param)
  },
  editSendConf(param) {
    return ajax.post(`${nameSpace}/identitymgr/updateSendConfig`, param)
  },
  saveReceConf(param) {
    return ajax.post(`${nameSpace}/identitymgr/saveReceConfig`, param)
  },
  editReceConf(param) {
    return ajax.post(`${nameSpace}/identitymgr/updateReceConfig`, param)
  },
  selectSender(params) {
    return ajax.get(`${nameSpace}/identitymgr/initSendList`, {
      params: params
    })
  },
  selectRece(params) {
    return ajax.get(`${nameSpace}/identitymgr/initReceList`, {
      params: params
    })
  },
  delRc(param) {
    return ajax.post(`${nameSpace}/identitymgr/deleteReceConfig`, param)
  },
  delSn(param) {
    return ajax.post(`${nameSpace}/identitymgr/deleteSendConfig`, param)
  },
  edit(param) {
    return ajax.post(`${nameSpace}/updateHsmInfo`, param)
  },
  InfoRece(uuid, a) {
    return ajax.get(`${nameSpace}/identitymgr/initReceList`, {
      params: {
        ai_uuid: a,
        uuid: uuid
      }
    })
  },
  InfoSend(uuid, a) {
    return ajax.get(`${nameSpace}/identitymgr/initSendList`, {
      params: {
        ai_uuid: a,
        uuid: uuid
      }
    })
  },
  startAllRes(){
    return ajax.get(`${nameSpace}/identitymgr/startall`)
  },

  identityResAllStart(uuid){
    return ajax.post(`${nameSpace}/identitymgr/identityResAllStart/${uuid}`)
  },
  identityResAllStop(uuid){
    return ajax.post(`${nameSpace}/identitymgr/identityResAllStop/${uuid}`)
  },
  identityResStartByuuid(param){
    return ajax.post(`${nameSpace}/identitymgr/identityResStartByuuid`, param)
  },
  identityResStopByuuid(param){
    return ajax.post(`${nameSpace}/identitymgr/identityResStopByuuid`, param)
  },
  queryMondataTable(iden_uuid){
    return ajax.get(`${nameSpace}/identitymgr/queryIdentityRes`, { params: { iden_uuid: iden_uuid } })
  }
}